import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import ReducersIndex from 'reduxModules/ducks';
import styled from "styled-components";
import Button from "components/molecules/Button";
import Attention from 'components/atoms/Attention';
import Tutorial from 'components/services/Tutorial';
import GetQuote from 'components/services/GetQuote';

const ToolHeader = forwardRef((props, ref) => {
  
  const dispatch = useDispatch();
  
  return (
  <ToolHeader.Wrapper ref={ref}>
    <h4 className={'col text-center py-0 my-1 fw-bold'} >{props.project}</h4>
    <div className="col-sm-auto hstack gap-1 p-0 align-items-unset">
      <Attention />
      <Button name={'edit'} onClick={() => dispatch(ReducersIndex.uiReducers.openModal('editProject'))}/>
      <Tutorial />
      <GetQuote {...props}/>
    </div>
  </ToolHeader.Wrapper>
)});

ToolHeader.Wrapper = styled.div.attrs(props => ({
  className: 'row justify-content-between',
}))`
  max-height: 38px;
  border: none;
  background: var(--app-light-gray);
  font-size: 18px
`;

export default ToolHeader;